import { render, staticRenderFns } from "./RightBtn.vue?vue&type=template&id=0d47832c&scoped=true&"
import script from "./RightBtn.vue?vue&type=script&lang=js&"
export * from "./RightBtn.vue?vue&type=script&lang=js&"
import style0 from "./RightBtn.vue?vue&type=style&index=0&id=0d47832c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d47832c",
  null
  
)

export default component.exports